<template>
  <div :class="appClass" id="userMenu1">
    <div class="frame-35582">
      <div class="frame-7">
        <router-link
          to="/"
          class="router-link-no-hover"
          aria-label="Credence Home"
        >
          <div class="frame-1" style="cursor: pointer">
            <img
              class="image-2"
              :src="getCDNlink('assets/logo_new.webp')"
              alt="Credence"
            />
          </div>
        </router-link>
      </div>
            <!-- Drawer Navigation Commented for Now-->
      <!-- <div
        v-if="showMobileMenu"
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          gap: 15px;
        "
      >
        <div class="hamburger-menu" @click="toggleDrawer">
          <div class="iconly-sharp-menu-instance">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="1.5"
                y1="1.5"
                x2="22.5"
                y2="1.5"
                stroke="black"
                stroke-width="3"
                stroke-linecap="round"
              />
              <line
                x1="1.5"
                y1="11.5"
                x2="22.5"
                y2="11.5"
                stroke="black"
                stroke-width="3"
                stroke-linecap="round"
              />
              <line
                x1="1.5"
                y1="21.5"
                x2="22.5"
                y2="21.5"
                stroke="black"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
      </div> -->
      <div v-if="showDrawer" class="bg-b-lue" v-on:click.self="toggleDrawer">
        <transition name="slide">
          <div class="drawer-navigation">
            <div
              class="drawer-item"
              v-if="!userTokenAvailable"
              @click="navigateOnPackageModule"
            >
              <div class="partnership" style="text-align: left">
                Buy Now
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- Buy Now Button -->
      <div class="frame-82">
        <button class="button2" @click="navigateOnPackageModule">
          <div
            class="section-icons"
            v-html="icons?.cart"
            style="margin-right: 7px"
          ></div>
          Buy Now
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import VueCookies from "vue-cookies";
import { mapGetters, mapActions } from "vuex";
import {
  Logout,
  GetCartItems,
  DeleteFromCart,
  CheckoutCart,
  GetMyReferrals,
} from "../api/APIs";
// import Drawer from "@/components/Drawer.vue";
import "floating-vue/dist/style.css";
import config from "@/config.js";
import { icons } from "@/assets/Icons/iconPaths";
import CompanyProfileIcons from "@/assets/DigitalReport/companyProfileIcons";
import router from "@/router";

export default {
  name: "App",
  components: {
  },
  data() {
    return {
      guestUser: true,
      userName: "",
      showLoaderPopup: false,
      showLoginPopup: false,
      showLogoutPopup: false,
      showHistoryPopup: false,
      showOrdersPopup: false,
      showOrderDetailsPopup: false,
      orderDetailsModel: null,
      manualOrderForm: false,
      availableCredits: 0,
      userToken: null,
      showDrawer: false,
      showMobileMenu: window.innerWidth < 1023,
      mobile: window.innerWidth <= 767,
      clickOutsideDrawer: false,
      loginType: "",
      isProduction: process.env.NODE_ENV === "production",
      profileMenuActive: false,
      profileMenuActive2: false,
      carouselSettings: [
        {
          dots: false,
          infinite: true,
          arrows: false,
          speed: 10000,
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 0,
          variableWidth: true,
          cssEase: "linear",
          rtl: false,
          pauseOnHover: false,
        },
        {
          dots: false,
          infinite: true,
          arrows: false,
          speed: 10000,
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 0,
          variableWidth: true,
          cssEase: "linear",
          rtl: true,
          pauseOnHover: false,
        },
      ],
      cartItemsList: [],
      toggleCheckoutModal: false,
      cartLoader: false,
      bulkOrderConfirmation: false,
      isCheckoutOpen: false,
      tooltipTimeout: null,
      showBoxShadow: false,
      showBlinking: false,
      myReferralList: [],
      showInviteNewUser: false,
      isTooltipOpen: false,
      shareOptions: [
        {
          type: "link",
          label: "Share Link",
          icon: "assets/SocialMediaIcons/link.webp",
        },
        {
          type: "whatsapp",
          label: "Whatsapp",
          icon: "assets/SocialMediaIcons/whatsapp.webp",
        },
        {
          type: "linkedin",
          label: "LinkedIn",
          icon: "assets/SocialMediaIcons/linkedin.webp",
        },
        {
          type: "twitter",
          label: "Twitter",
          icon: "assets/SocialMediaIcons/x.webp",
        },
      ],
      referralCredits: config.referralCredits,
      drawerOpen: false,
      rewardsDrawerOpen: false,
      cartValidity: false,
      cartValidityData: null,
      isCollapsed: false,
      waringType: this.warning,
      flag: false,
      isLanguageModalOpen: false,
      allLanguages: [
        { code: "en", language: "English", region: "Global", flag: "gb" },
        { code: "ar", language: "العربية", region: "Arab", flag: "ae" },
        { code: "zh", language: "中文", region: "China", flag: "cn" },
        { code: "bn", language: "বাংলা.", region: "Bengali", flag: "bd" },
        { code: "ja", language: "日本語", region: "Japanese", flag: "jp" },
        { code: "ko", language: "한국어", region: "Korean", flag: "kr" },
        { code: "th", language: "ไทย", region: "Thai", flag: "th" },
        {
          code: "vi",
          language: "Tiếng Việt",
          region: "Vietnamese",
          flag: "vn",
        },
      ],
      enableTranslation: process.env.VUE_APP_ENABLE_TRANSLATION === "true",
      showPartialFailureModal: false,
      partialFailureData: {
        message: "",
        failedOrders: [],
        paymentRequired: false,
        paymentUrl: "",
      },
    };
  },
  computed: {
    icons() {
      return CompanyProfileIcons;
    },
    ...mapGetters([
      "cartCount",
      "sessionExpired",
      "userDetails",
      "warning",
      "toasts",
      "selectedLanguage",
    ]),
    isDigitalReport() {
      return this.$route.name !== "DigitalReport";
    },
    currentLanguage() {
      return this.$i18n.locale;
    },
    hasRewards() {
      return this.userDetails?.includes("REWARDS");
    },
    hasCredits() {
      return this.userDetails?.includes("CREDIT_MANAGEMENT");
    },
    hasCart() {
      return this.userDetails?.includes("ORDERS");
    },
    isNotificationEnabled() {
      return this.warning && this.warning !== "NORMAL";
    },
    options() {
      const routeMap = {
        SEARCH: {
          label: this.$t("search"),
          route: "/search",
          params: "",
          icon: "search",
        },
        DASHBOARD: {
          label: this.$t("dashboard"),
          route: "/bankuserdashboard",
          params: "",
          icon: "dashboard",
        },
        ORDERS: {
          label: this.$t("orders"),
          route: "/MyOrders",
          params: "?tab=active-orders",
          icon: "orders",
        },
        TEAMS: {
          label: this.$t("manage-team"),
          route: "/profile",
          params: "?tab=teams",
          icon: "team",
        },
        HELPDESK: {
          label: this.$t("helpdesk"),
          route: "/contact",
          params: "",
          icon: "helpdesk",
        },
        "ADMIN-CONSOLE": {
          label: this.$t("admin-portal"),
          route: "/banks-&-hq",
          params: "",
          icon: "bank",
        },
        "BLOG-EDITOR": [
          {
            label: this.$t("post-blog"),
            route: "/blog-editor",
            params: "",
            icon: "blog",
          },
          {
            label: this.$t("edit-blog"),
            route: "/existing-blogs",
            params: "",
            icon: "blog",
          },
        ],
      };
      return this.userDetails
        ?.flatMap((option) => routeMap[option] || [])
        .filter(Boolean);
    },
    referralCode() {
      return this.$store.getters.referralCode;
    },
    credits() {
      return this.$store.getters.credits;
    },
    updatedCartList() {
      return this.cartItemsList;
    },
    updatedInvites() {
      return this.myReferralList;
    },
    currentScreenName() {
      const routeName = this.$route.name || "";
      const localizedNames = this.$route.meta.localizedNames || {};
      let localizedName = localizedNames[this.selectedLanguage?.code];
      if (localizedName) {
        localizedName = localizedName
          .replace(/-/g, " ")
          .replace(/([a-z])([A-Z])/g, "$1 $2")
          .replace(/^./, (str) => str.toUpperCase());
      } else {
        localizedName = routeName
          .replace(/-/g, " ")
          .replace(/([a-z])([A-Z])/g, "$1 $2")
          .replace(/^./, (str) => str.toUpperCase());
      }
      return localizedName;
    },
    // authorisedUserType() {
    //   return ["HEAD", "MANAGER"].includes(VueCookies.get("user-type"));
    // },
    userType() {
      return ["HEAD", "MANAGER", "EXECUTIVE"].includes(
        VueCookies.get("user-type")
      );
    },
    isRetail() {
      return VueCookies.get("user-type") === "RETAIL";
    },
    isAdmin() {
      return VueCookies.get("user-type") === "BLOG-ADMIN";
    },
    userTokenAvailable() {
      return this.userToken !== null;
    },
    appClass() {
      return this.userTokenAvailable ? "#app.logged-in" : "#app.not-logged-in";
    },
    isActiveRoute() {
      return (path, query = {}) => {
        const isSamePath = this.$route.path === path;
        const isSameQuery = Object.keys(query).every(
          (key) => this.$route.query[key] === query[key]
        );
        const hasNoQuery = Object.keys(query).length === 0;
        return isSamePath && (isSameQuery || hasNoQuery);
      };
    },
    truncatedUserName() {
      const user = this.userName || VueCookies.get("user");
      if (user) {
        return user;
      } else {
        return "";
      }
    },
  },
  beforeMount() {
    this.userName = VueCookies.get("user");
    this.userToken = VueCookies.get("token");
  },
  watch: {
    toasts: {
      handler(newToasts) {
        if (newToasts.length > 0) {
          setTimeout(() => {
            newToasts.forEach((toast) => {
              if (this.$refs.toastContainer) {
                this.$refs.toastContainer.addToast(toast.message, {
                  type: toast.type,
                });
              } else {
                console.warn("Toast container not found.");
              }
            });
            this.$store.commit("clearToasts");
          }, 0);
        }
      },
      deep: true,
      immediate: true,
    },
    selectedLanguage: {
      handler(newLang) {
        this.$store.dispatch("updateSelectedLanguage", newLang);
        this.$i18n.locale = newLang.code;
      },
      deep: true,
    },
    $route(to) {
      if (to.path !== "/login") {
        this.handleMountedLogic();
      }
      if (
        VueCookies.get("token") &&
        VueCookies.get("order-count") == 0 &&
        localStorage.getItem("effectTriggered") === "false"
      ) {
        this.triggerBoxShadow();
        localStorage.setItem("effectTriggered", true);
      }
    },
  },
  mounted() {
    this.getStoredLanguage();
    const storedState = sessionStorage.getItem("isCollapsed");
    if (storedState !== null) {
      this.isCollapsed = storedState === "true";
    }
    if (this.$route.path !== "/login") {
      this.handleMountedLogic();
    }
    window.addEventListener("resize", this.handleResize);
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener("click", this.handleClickOutside2);
    document.addEventListener("scroll", this.handleScroll);
    // Watch for changes in localStorage and update state
    window.addEventListener("storage", (event) => {
      if (event.key === "selectedLanguage") {
        const newLang = JSON.parse(event.newValue);
        this.$store.dispatch("updateSelectedLanguage", newLang);
        this.$i18n.locale = newLang.code;
      }
    });
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("click", this.handleClickOutside2);
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("storage", this.handleStorageChange);
  },
  updated() {
    window.scrollTo(0, 0);
  },
  methods: {
    trackBuyNowClick() {
      if (typeof window.gtag === "function") {
        const route = this.$route;
        window.gtag("event", "buy_now_click", {
          event_category: "engagement",
          event_label: `${route.params.company} - ${route.params.country}`,
          company_name: route.params.company,
          country: route.params.country,
          page_path: route.fullPath,
          page_location: window.location.href,
          page_title: document.title,
          transport_type: "beacon", // ✅ this is key!
        });
      }
    },
    navigateOnPackageModule() {
      this.trackBuyNowClick(); // ✅ Send first
      setTimeout(() => {
        router.push(
          `/choose-package/${this.$route?.href?.split("/company-profile/")[1]}`
        );
      }, 200);
    },
    ...mapActions(["updateCartCount"]),
    getStoredLanguage() {
      const savedLanguage = JSON.parse(
        localStorage.getItem("selectedLanguage")
      );
      if (savedLanguage) {
        this.$store.dispatch("updateSelectedLanguage", savedLanguage);
        this.$i18n.locale = savedLanguage.code;
      } else {
        const userLanguage = navigator.language?.split("-")[0]?.toLowerCase();
        const foundLanguage = this.allLanguages.find(
          (lang) => lang?.code === userLanguage
        );
        // If language is present, then set to that code
        if (foundLanguage) {
          this.$store.dispatch("updateSelectedLanguage", foundLanguage);
          this.$i18n.locale = foundLanguage?.code;
        } else {
          //If not, then default to english
          const lang = this.allLanguages.find((lang) => lang?.code === "en");
          this.$store.dispatch("updateSelectedLanguage", lang);
          this.$i18n.locale = "en";
        }
      }
    },
    openLanguageModal() {
      this.isLanguageModalOpen = true;
    },
    closeLanguageModal() {
      this.isLanguageModalOpen = false;
    },
    handleLanguageSelect(language) {
      this.$i18n.locale = language.code;
      this.isLanguageModalOpen = false;
    },
    getIcon(iconName) {
      return icons[iconName.split(".")[0]] || "";
    },
    redirectToCredits() {
      this.drawerOpen = false;
      this.$router.push({ path: "/profile", query: { tab: "credits" } });
    },
    goBackToSearch() {
      this.$router.push("/search");
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      sessionStorage.setItem("isCollapsed", this.isCollapsed);
    },
    initiateTokenExpiryHandler() {
      const tokenCreationTime = VueCookies.get("token-creation-time");
      const currentTime = Date.now();

      if (tokenCreationTime) {
        const tokenAge = currentTime - new Date(tokenCreationTime).getTime();
        const expiryTime = 12 * 60 * 60 * 1000;
        const remainingTime = expiryTime - tokenAge;

        if (remainingTime > 0) {
          setTimeout(() => {
            this.$store.dispatch("processLogout");
          }, remainingTime);
        } else {
          this.$store.dispatch("processLogout");
        }
      } else {
        console.warn("Token creation time not found.");
      }
    },

    handleScroll() {
      if (this.profileMenuActive2) {
        this.profileMenuActive2 = false;
      }
    },
    navBarCkicked() {
      this.drawerOpen = false;
      this.rewardsDrawerOpen = false;
    },
    toggleTooltip() {
      this.isTooltipOpen = !this.isTooltipOpen;
    },
    handleShare(type) {
      this.toggleTooltip();
      const baseUrl = window.location.origin;
      const referralMessage = `${this.$t("referal-message-1")} ${
        this.referralCode
      },
      ${this.$t("referal-message-2")} ${this.referralCredits} ${this.$t(
        "referal-message-3"
      )} :) ${this.$t("referal-message-4")}
      ${baseUrl}/login?type=SignUp&refCode=${this.referralCode}`;
      const referralLink = `${baseUrl}/login?type=SignUp&refCode=${this.referralCode}`;
      if (type === "link") {
        this.copyToClipboard(true);
      } else {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        let shareUrl;
        switch (type) {
          case "whatsapp":
            shareUrl = `https://wa.me/?text=${encodeURIComponent(
              referralMessage
            )}`;
            break;
          case "linkedin":
            shareUrl = `https://www.linkedin.com/sharing/share-offsite/?text=${encodeURIComponent(
              referralMessage
            )}`;
            break;
          case "twitter":
            shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
              referralMessage
            )}`;
            break;
        }

        if (isMobile) {
          const appUrl = this.getAppUrl(type, referralMessage, referralLink);
          window.location.href = appUrl;
          setTimeout(() => {
            window.location.href = shareUrl;
          }, 1000);
        } else {
          window.open(shareUrl, "_blank");
        }
      }
    },
    getAppUrl(type, referralMessage) {
      switch (type) {
        case "whatsapp":
          return `whatsapp://send?text=${encodeURIComponent(referralMessage)}`;
        case "linkedin":
          return `linkedin://shareArticle?mini=true&text=${encodeURIComponent(
            referralMessage
          )}`;
        case "twitter":
          return `twitter://post?message=${encodeURIComponent(
            referralMessage
          )}`;
        default:
          return "";
      }
    },
    toggleInviteNewUser() {
      this.showInviteNewUser = !this.showInviteNewUser;
    },
    copyToClipboard(message) {
      const baseUrl = window.location.origin;
      const referralMessage = `${this.$t("referal-message-1")} ${
        this.referralCode
      },
      ${this.$t("referal-message-2")} ${this.referralCredits} ${this.$t(
        "referal-message-3"
      )} :) ${this.$t("referal-message-4")}
      ${baseUrl}/login?type=SignUp&refCode=${this.referralCode}`;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(message ? referralMessage : this.referralCode)
          .then(() => {
            alert(
              message
                ? this.$t("copied-clipboard")
                : this.$t("referal-code-copied")
            );
          })
          .catch((err) => {
            console.error("Failed to copy: ", err);
          });
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = message ? referralMessage : this.referralCode;
        textarea.style.position = "fixed";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand("copy");
          alert(this.$t("referal-code-copied"));
        } catch (err) {
          console.error(
            message
              ? this.$t("copied-clipboard")
              : "Fallback: Oops, unable to copy",
            err
          );
        }
        document.body.removeChild(textarea);
      }
    },
    triggerBoxShadow() {
      this.showBoxShadow = true;
      this.showBlinking = true;
      setTimeout(() => {
        this.showBoxShadow = false;
        this.showBlinking = false;
      }, 20000);
    },
    toggleCheckoutTooltip() {
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout);
      }

      this.isCheckoutOpen = !this.isCheckoutOpen;

      if (this.isCheckoutOpen) {
        this.tooltipTimeout = setTimeout(() => {
          this.isCheckoutOpen = false;
        }, 3000);
      }
    },
    async toggleWishlist() {
      try {
        await this.GetCartItems();
        if (this.mobile) {
          this.showDrawer = false;
        }
        this.drawerOpen = !this.drawerOpen;
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    },
    async toggleRewards() {
      try {
        if (this.rewardsDrawerOpen === false) {
          await this.MyReferrals();
        }
        this.rewardsDrawerOpen = !this.rewardsDrawerOpen;
      } catch (error) {
        console.error("Error fetching rewards:", error);
      }
    },
    async toggleCheckout() {
      try {
        this.toggleCheckoutModal = !this.toggleCheckoutModal;
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    },
    toggleBulkOrderConfirmation() {
      this.bulkOrderConfirmation = !this.bulkOrderConfirmation;
    },
    async GetCartItems() {
      try {
        const response = await GetCartItems();
        if (response.cart) {
          this.cartItemsList = response.cart;
          this.cartValidity = response.cartValidityExpiring
            ? response.cartValidityExpiring
            : false;
          this.cartValidityData = response.cartValidityDate
            ? response.cartValidityDate
            : null;
          this.updateCartCount(response?.size);
          this.flag = response.insufficientCreditsFlag;
          if (response.lowCreditBalanceFlag)
            this.$store.dispatch("setWarning", response.lowCreditBalanceFlag);
        } else {
          return this.$refs.toastContainer.addToast(response.message, {
            type: "error",
          });
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    async MyReferrals() {
      try {
        const response = await GetMyReferrals();
        if (response) {
          this.myReferralList = response;
        } else {
          return this.$refs.toastContainer.addToast(response.message, {
            type: "error",
          });
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    async placeBulkOrder(deliveryEmail, isDiscountApplied) {
      this.cartLoader = true;
      const payload =
        this.isRetail === true
          ? {
              email: deliveryEmail,
              isDiscountApplied: isDiscountApplied,
            }
          : {
              email: deliveryEmail,
            };
      try {
        const response = await CheckoutCart(payload);
        if (response?.data?.message === "SUCCESS") {
          if (response?.status === 201) {
            this.partialFailureData = {
              message:
                response?.data?.result?.partialFailureMessage ||
                "Some orders could not be processed",
              failedOrders: response?.data?.result?.failedOrdersFromCart || [],
              paymentRequired: response?.data?.result?.paymentRequired || false,
              paymentUrl: response?.data?.result?.paymentLink || "",
            };
            this.toggleCheckout();
            this.cartLoader = false;
            this.showPartialFailureModal = true;
            this.drawerOpen = false;
          } else if (
            this.isRetail === true &&
            response?.data?.result?.paymentRequired
          ) {
            this.cartLoader = false;
            this.GetCartItems();
            this.toggleCheckout();
            this.drawerOpen = false;
            window.location.href = response?.data?.result?.paymentLink;
          } else {
            this.cartLoader = false;
            this.GetCartItems();
            this.toggleCheckout();
            this.drawerOpen = false;
            this.toggleBulkOrderConfirmation();
          }
        } else {
          return this.$refs.toastContainer.addToast(response?.data?.message, {
            type: "error",
          });
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    handlePartialFailureClose() {
      this.showPartialFailureModal = false;
      this.GetCartItems();
    },
    handlePaymentProceed() {
      if (this.partialFailureData.paymentUrl) {
        window.location.href = this.partialFailureData.paymentUrl;
      }
      this.showPartialFailureModal = false;
    },

    handlePaymentCancel() {
      this.showPartialFailureModal = false;
      this.GetCartItems();
    },
    async deleteFromCart(item, clearCart) {
      const payload = clearCart
        ? { clearCart: clearCart }
        : { itemId: item.id };
      try {
        const response = await DeleteFromCart(payload);
        if (response.message === "Deleted from cart") {
          this.GetCartItems();
        } else if (response.message === "Cart cleared") {
          this.GetCartItems();
        } else {
          return this.$refs.toastContainer.addToast(response.message, {
            type: "error",
          });
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    redirectToLogin() {
      this.tokenExpired();
      this.$store.commit("setSessionExpired", false);
    },
    profileClicked() {
      this.profileMenuActive = !this.profileMenuActive;
    },
    profileClicked2() {
      this.profileMenuActive2 = !this.profileMenuActive2;
    },
    handleClickOutside2(event) {
      if (
        this.profileMenuActive2 &&
        this.$refs.profileMenu2 &&
        this.$refs.profile2 &&
        !this.$refs.profileMenu2.contains(event.target) &&
        !this.$refs.profile2.contains(event.target)
      ) {
        this.profileMenuActive2 = false;
      }
    },
    handleClickOutside(event) {
      if (
        this.profileMenuActive &&
        this.$refs.profileMenu &&
        this.$refs.profile &&
        !this.$refs.profileMenu.contains(event.target) &&
        !this.$refs.profile.contains(event.target)
      ) {
        this.profileMenuActive = false;
      }
    },
    goToProfile() {
      this.profileMenuActive = false;
      this.profileMenuActive2 = false;
      this.$router.push("/profile?tab=myaccount");
    },
    redirectToAboutUs() {
      this.$router.push("/aboutus");
      this.showDrawer = false;
    },
    redirectToInstitutions() {
      this.$router.push("/institutions");
      this.showDrawer = false;
    },
    redirectToPartnerships() {
      this.$router.push("/partnerships");
      this.showDrawer = false;
    },
    redirectToBlogs() {
      this.$router.push("/blogs");
      this.showDrawer = false;
    },
    redirectToProducts() {
      this.$router.push("/product");
      this.showDrawer = false;
    },
    redirectToHome() {
      if (this.$route.path === "/") {
        location.reload();
      } else {
        this.$router.push("/");
        this.showDrawer = false;
      }
    },
    handleMountedLogic() {
      this.userToken = VueCookies.get("token");
      this.userName = VueCookies.get("user");
    },
    toggleDrawer() {
      this.showDrawer = !this.showDrawer;
    },
    handleResize() {
      this.showMobileMenu = window.innerWidth < 1023;
    },
    showLoader() {
      this.showLoaderPopup = true;
    },
    hideLoader() {
      this.showLoaderPopup = false;
    },
    showLogin(actionType) {
      this.loginType = actionType;
      this.$router.push({ path: "/login", query: { type: actionType } });
    },
    async processLogout() {
      const user = VueCookies.get("email");
      const token = VueCookies.get("token");
      try {
        const response = await Logout(user, token);
        if (response) {
          this.profileMenuActive = false;
          localStorage.setItem("effectTriggered", false);
          this.$store.dispatch("clearData");
          const cookiesToRemove = [
            "token",
            "user",
            "password",
            "email",
            "user-type",
            "id",
            "designation",
            "designationId",
            "phone",
            "order-count",
            "entityId",
            "branch",
            "RM",
            "phone_w_countryCode",
            "token-creation-time",
            "EntityType",
          ];
          if (sessionStorage.getItem("isCollapsed")) {
            sessionStorage.removeItem("isCollapsed");
          }
          cookiesToRemove.forEach((cookie) => {
            if (VueCookies.get(cookie)) {
              VueCookies.remove(cookie);
            }
          });
          const sessionStorageToClear = [
            "isCollapsed",
            "allCountriesList",
            "selectedCountry",
          ];
          sessionStorageToClear.forEach((variable) => {
            if (sessionStorage.getItem(variable)) {
              sessionStorage.removeItem(variable);
            }
          });
          this.userToken = null;
          this.userName = "";
          window.location.href = "/";
        }
      } catch (error) {
        console.error(error);
      }
    },
    async tokenExpired() {
      const user = VueCookies.get("email");
      const token = VueCookies.get("token");
      try {
        const response = await Logout(user, token);
        if (response) {
          this.profileMenuActive = false;
          this.profileMenuActive2 = false;
          localStorage.setItem("effectTriggered", false);
          this.$store.dispatch("clearData");
          const cookiesToRemove = [
            "token",
            "user",
            "password",
            "email",
            "user-type",
            "id",
            "designation",
            "designationId",
            "phone",
            "order-count",
            "entityId",
            "branch",
            "RM",
            "phone_w_countryCode",
            "token-creation-time",
            "EntityType",
          ];

          cookiesToRemove.forEach((cookie) => {
            if (VueCookies.get(cookie)) {
              VueCookies.remove(cookie);
            }
          });
          this.userToken = null;
          this.userName = "";
          this.$router.push({ path: "/login", query: { type: "Login" } });
        }
      } catch (error) {
        console.error(error);
      }
    },
    getCDNlink(fileKey) {
      let baseUrl = "";
      if (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "staging"
      ) {
        baseUrl = config.stagingCDN;
      } else if (process.env.NODE_ENV === "production") {
        baseUrl = config.prodCDN;
      }

      return `${baseUrl}${fileKey}`;
    },
  },
};
</script>
<style scoped>
/* Main container */
#userMenu1 {
  background: #e0f5ff;
  width: 100%;
  /* position: fixed;
  top: 0;
  left: 0; */
  margin: 0 !important;
  /* -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  background: linear-gradient(
    180deg,
    #1c1c1c,
    rgba(28, 28, 28, 0.5) 50%,
    rgba(28, 28, 28, 0)
  ); */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px 12px;
  box-sizing: border-box;
  z-index: 1000;
  gap: 0px;
  text-align: left;
  font-size: 16px;
  color: #fff;
  font-family: "Figtree";
}
#userMenu1 p {
  float: left;
  display: block;
  color: #f2f2f2;
  text-align: center;
  text-decoration: none;
  margin-left: 16px;
}

#userMenu1 a {
  float: right;
  display: flex;
  color: #1d375b;
  font-weight: bold;
  text-align: center;
  padding: 16px 16px;
  text-decoration: none;
  position: relative;
  /* left: -3%; */
}

#userMenu1 a:hover {
  background: #f1f8f8;
  color: black;
}
.frame-35582 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  width: -webkit-fill-available;
  position: relative;
}

/* Navigation links container */
.frame-7 {
  display: flex;
  flex-direction: row;
  gap: 36px;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}

/* Logo container */
.frame-1 {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}

/* Logo image */
.image-2 {
  flex-shrink: 0;
  width: 173px;
  position: relative;
  object-fit: cover;
}

/* Navigation items */
.frame-4,
.frame-5,
.frame-72,
.frame-9 {
  border-radius: 16px;
  padding: 16px 0;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}

/* Navigation links */
.partnership,
.blogs,
.about {
  color: #1c1c1c;
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  font-weight: 600;
  position: relative;
  cursor: pointer;
  letter-spacing: 1px;
  text-decoration: none;
  transition: opacity 0.2s ease;
}
.section-icons {
  display: flex;
  width: 20px;
}

.partnership:hover,
.blogs:hover,
.about:hover {
  opacity: 0.8;
}

/* Active tab */
.active-tab {
  color: #fff !important;
  font-weight: bold;
  text-decoration: underline;
  text-underline-offset: 4px;
}

/* Right side container */
.frame-82 {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  position: relative;
}

/* Language selector */
.select-language1 {
  cursor: pointer;
}

.language-capsule {
  display: flex;
  align-items: center;
  border-radius: 20px;
  padding: 6px 12px;
  gap: 8px;
  border: 1.5px solid #fff;
  background: transparent;
  color: #fff;
  font-family: "Figtree";
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.language-capsule:hover {
  background: rgba(255, 255, 255, 0.1);
}

.language-capsule-name {
  font-weight: 600;
}
.button2 {
  cursor: pointer;
  border-radius: 12px;
  background: #fd4c8c;
  box-shadow: 1px 0px 5px #fd4c8c;
  color: #f8fafc;
  display: inline-flex;
  /* Keeps button width dynamic */
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  box-sizing: border-box;
  width: fit-content;
  /* Ensures it fits text width */
  min-width: unset;
  max-width: 100%;
  /* Prevents it from overflowing */
  position: relative;
  font-weight: 500;
  white-space: nowrap;
  /* Prevents text from wrapping */
  overflow: visible;
  /* Ensures full content visibility */
  text-align: center;
  border: none;
}

/* Hamburger menu */
.hamburger-menu {
  display: none;
  cursor: pointer;
  padding: 8px;
}

/* Drawer navigation */
.bg-b-lue {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
}

.drawer-navigation {
  width: 280px;
  height: 100%;
  background-color: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  animation: slideIn 0.3s ease-out;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
}

.drawer-item {
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.drawer-item:hover {
  background-color: #f5f5f5;
}

.drawer-item:last-child {
  border-bottom: none;
}

/* Animation for drawer */
@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Router link styling */
.router-link-no-hover {
  text-decoration: none;
  color: inherit;
  background-color: transparent !important;
}

.router-link-no-hover:hover {
  text-decoration: none;
}

/* Responsive styles */
@media (max-width: 1024px) {
  .frame-35582 {
    padding: 12px 24px;
  }

  .frame-7 {
    gap: 20px;
  }
}

@media (max-width: 768px) {

  .hamburger-menu {
    display: block;
  }

  .show-mobile {
    display: flex !important;
  }

  .frame-82 {
    gap: 8px;
  }
}

@media screen and (max-width: 480px) {
    #userMenu1 a{
        padding:0px;
    }
    .frame-35582 {
    padding: 0px;
  }
}
</style>
